<template>
    <div>
        <div class="tw-flex tw-border-b tw-mb-4 tw-max-w-full tw-overflow-x-auto" :class="buttonsContainerClass" v-if="$slots.buttons">
            <slot name="buttons" :set="set"></slot>
        </div>

        <div class="tw-w-full">
            <div class="tw-flex" ref="slider">
                <slot name="default" :update-tabs="updateTabs" :set="set" :current-tab="current"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TabGroup",

    props: {
        useHashes: {
            type: Boolean,
            default: true
        },
        transition: {
            type: Boolean,
            default: false
        },
        buttonsContainerClass: String
    },

    data() {
        return {
            tabs: {},
            buttons: {},
            current: null
        }
    },

    mounted() {
        
        // Gather all child base-tab components in an object that can be referenced by the tab's name
        this.findTabs();

        // On page load, if there is a hash in the uri that matches a tab in the group, set that tab as the active one
        // Otherwise, set the first tab to active
        this.$nextTick(() => {
            let hash = window.location.hash.substring(1);
            if(this.useHashes && Object.keys(this.tabs).includes(hash)) {
                this.set(hash);
            } else {
                // Set the first tab as active
                this.set(Object.keys(this.tabs)[0]);
            }
        });

        // When the hash changes
        // If the tab group includes a tab with a matching name, set that tab to the active one
        if(this.useHashes) {
            window.addEventListener('hashchange', () => {
                let hash = window.location.hash.substring(1);

                if(Object.keys(this.tabs).includes(hash)) {
                    this.set(hash);
                }
            });
        }

        // Transitions
        setTimeout(() => {
            this.$refs.slider.addEventListener('transitionend', event => {
                if(event.target == this.$refs.slider) {
                    this.update();
                }
            });
        }, 500);

    },

    methods: {
        set(value) {
            console.log("new tab: " + value);
            // Only run if changing tabs
            if(value == this.current) {
                return;
            }

            let oldTab = this.current;
            this.current = value;

            // Display the requested tab
            this.tabs[value].toggle(true);
            this.buttons?.[value]?.toggle(true);

            if(this.transition) {
                // Transition to the new tab. Don't use transitions if running set() for the first time.
                if(oldTab) {
                    this.$el.style.overflowX = "hidden";
                    
                    // Start the transition on the next tick to allow for changes in width due to the scrollbar
                    this.$nextTick(() => {
                        let tabs = Object.values(this.tabs).map(tab => tab.name);

                        let distance = this.$el.clientWidth + 25;

                        if(tabs.indexOf(value) < tabs.indexOf(oldTab)) {
                            this.translateTo(-distance)

                            setTimeout(() => {
                                this.enableTransition();

                                this.$nextTick(() => {
                                    this.translateTo(0);
                                });
                            }, 1);
                        } else {
                            this.enableTransition();

                            setTimeout(() => {
                                this.translateTo(-distance);
                            }, 1);
                        }
                    });
                }
            } else {
                this.update();
            }
        },

        enableTransition() {
            this.$refs.slider.style.transition = "transform 300ms";
        },

        translateTo(coordinate) {
            this.$refs.slider.style.transform = `translateX(${coordinate}px)`
        },

        update() {
            // Update the DOM to represent any changes

            // Turn off all tabs besides the current one
            for(let tab of Object.keys(this.tabs).filter(tab => tab != this.current)) {
                this.tabs[tab].toggle(false);
                this.buttons?.[tab]?.toggle(false);
            }

            // Reset the transform
            this.$refs.slider.style.transition = null;
            this.$refs.slider.style.transform = null;
            this.$el.style.overflowX = null;
        },

        findTabs(){
            for(let child of this.$children) {
                if(child.$options._componentTag == 'base-tab') {
                    this.tabs[child.$props.name] = child;
                } else if(child.$options._componentTag == 'tab-button') {
                    this.buttons[child.$props.for] = child;
                    child.useHashes = this.useHashes;

                    if(!this.useHashes) {
                        child.$off('click', () => {
                            this.set(child.$props.for);
                        });

                        child.$on('click', () => {
                            this.set(child.$props.for);
                        });
                    }
                }
            }
        },

        updateTabs(){
            this.$nextTick(() => {
                this.findTabs();
            });
        }
    }
}
</script>

<style>

</style>